import React from "react";
import "./CommonErrorPopup.css";

export default function CommonErrorPopup({ open, message, onClose }) {
  if (!open) return null;
  const lines = String(message || "Please fill out the text box.")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  return (
    <div className="common-error-backdrop" role="presentation">
      <div className="common-popup-card common-popup-card--error" role="alert" aria-live="assertive">
        <div className="common-popup-badge common-popup-badge--error" aria-hidden="true">
          x
        </div>
        <div className="common-error-message">
          {lines.length > 0 ? (
            lines.map((line, idx) => (
              <div
                key={`${line}-${idx}`}
                className={idx === 0 ? "common-error-line common-error-line--primary" : "common-error-line common-error-line--secondary"}
              >
                {line}
              </div>
            ))
          ) : (
            "Please fill out the text box."
          )}
        </div>
        <button type="button" className="common-popup-button common-popup-button--error" onClick={onClose}>
          ok
        </button>
      </div>
    </div>
  );
}
